import './index.scss'
import React from 'react'
import { connect } from 'react-redux'
import { facebokLoginRequest } from '../../../../action/auth-actions'

class SignUpWithFacebook extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      facebookAuthResponse: {}
    }
  }

  componentDidMount() {
    this.loadFaceApi()
  }

  loadFaceApi() {
    window.fbAsyncInit = () => {
      FB.init({
        appId: __APP_ID__,
        cookie: true, // enable cookies to allow the server to access
        // the session
        xfbml: true, // parse social plugins on this page
        version: 'v22.0' // keep in step with GraphApiVersion in services/FacebookTokenService.cs
      })
    }

      // Load the SDK asynchronously
      ; ((d, s, id) => {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = '//connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')
  }

  loginBaseMapAPI() {

    FB.api('/me?fields=picture.width(400).height(400),id,name,email', response => {
      if (!response || response.error) {
        // $('#login-email-error').html(response.error.message)
      } else {
        let name = response.name.split(' ')
        const authObject = {
          fbToken: this.state.facebookAuthResponse.accessToken,
          stateName: '',
          photoUrl: response.picture.data.url,
          loginProviderId: 1,
          externalLoginId: '',
          email: response.email,
          password: '',
          deviceId: '',
          firstName: name[0],
          lastName: name[1]
        }

        this.props.FBlogin(authObject)
          .catch(err => console.log(err.response ? err.response.text : err))
      }


    })
  }

  statusChangeCallback(response) {
    if (response.status === 'connected') {
      this.setState({ facebookAuthResponse: response.authResponse }, () => {
        this.loginBaseMapAPI()
      })

    } else if (response.status === 'not_authorized') {
      console.log('Need to log into this app.')
    } else {
      console.log('Need to log into this facebook.')
    }
  }

  checkLoginState() {
    FB.getLoginStatus(
      response => {
        this.statusChangeCallback(response)
      },
      {
        scope: 'email,public_profile',
        return_scopes: true
      }
    )
  }

  handleLogin(e) {
    e.preventDefault()
    FB.login(this.checkLoginState())
  }

  render() {
    return (
      <div className="button-facebook">
        <button id="facebook-login" className="bm-ripple"
        // onClick={e => this.handleLogin(e)}
        >
          <img src="../../../asset/Logo_Facebook-F_FFFFFFhdpi.png" />
          Sign Up with Facebook
        </button>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
  FBlogin: fbauthObj => dispatch(facebokLoginRequest(fbauthObj))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpWithFacebook)
